import { Link, useLocation } from 'react-router-dom';
import { Icon } from '@iconify/react';
import { useState } from 'react';
import { MAILTO } from '../../pages/LandingPage';

const sections = [
  { id: 'about', label: 'About' },
  { id: 'leadership', label: 'Leadership' },
  { id: 'contact', label: 'Contact' },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  // On the landing page the links scroll; on Terms/Privacy they go back to the section.
  const href = (id) => (pathname === '/' ? `#${id}` : `/#${id}`);

  return (
    <header className="sticky top-0 z-50 bg-[#0a1628]">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between">
          <Link to="/" className="flex items-center gap-3" onClick={() => window.scrollTo(0, 0)}>
            <img src="/logos/discx/discx-icon-3D.png" alt="" className="h-10 w-10 drop-shadow-lg" />
            <span className="flex items-baseline text-xl font-bold" dir="ltr">
              <span className="text-white">DiSCX-</span>
              <span className="text-[#93c5fd]">US</span>
            </span>
          </Link>

          <nav className="hidden items-center gap-1 md:flex">
            {sections.slice(0, 2).map((s) => (
              <a key={s.id} href={href(s.id)} className="rounded-lg px-4 py-2 text-sm font-medium text-white/90 transition-all hover:bg-white/5 hover:text-white">
                {s.label}
              </a>
            ))}
            <a href={MAILTO} className="ml-2 rounded-lg bg-[#2563eb] px-4 py-2 text-sm font-semibold text-white shadow-md transition-colors hover:bg-[#1d4ed8]">
              Contact Us
            </a>
          </nav>

          <button type="button" onClick={() => setOpen(!open)} aria-label="Menu" className="rounded-lg p-2 text-white hover:bg-white/10 md:hidden">
            <Icon icon={open ? 'mdi:close' : 'mdi:menu'} className="h-6 w-6" />
          </button>
        </div>
      </div>
      {open && (
        <nav className="space-y-1 border-t border-white/10 px-4 py-3 md:hidden">
          {sections.map((s) => (
            <a key={s.id} href={href(s.id)} onClick={() => setOpen(false)} className="block rounded-lg px-4 py-2 text-sm font-medium text-white/90 hover:bg-white/5">
              {s.label}
            </a>
          ))}
        </nav>
      )}
    </header>
  );
}
